<template>
  <div class="d-flex flex-column h-100">
    <div class="row flex-grow-1">
      <div class="col-sm-12 col-md-6 col-lg">
        <BQdtCard
          name="paymKPI1"
          with-fullscreen
        />
      </div>
      <div class="col-sm-12 col-md-6 col-lg">
        <BQdtCard
          name="paymKPI2"
          with-fullscreen
        />
      </div>
      <div class="col-sm-12 col-md-6 col-lg">
        <BQdtCard
          name="paymKPI3"
          with-fullscreen
        />
      </div>
      <div class="col-sm-12 col-md-6 col-lg">
        <BQdtCard
          name="paymKPI4"
          with-fullscreen
        />
      </div>
    </div>
    <div class="row flex-grow-2">
      <div class="col-sm-12 col-md-6 col-lg-9">
        <div class="row h-100">
          <div class="col-12">
            <BQdtCard
              name="paymDyn1"
              with-fullscreen
            />
          </div>
          <div class="col-12">
            <BQdtCard
              name="paymDyn2"
              with-fullscreen
            />
          </div>
        </div>
      </div>
      <div class="col-sm-12 col-md-6 col-lg-3">
        <div class="row h-100">
          <div class="col-12">
            <BQdtCard name="paymKPI5" />
          </div>
          <div class="col-12">
            <BQdtCard name="paymKPI6" />
          </div>
          <div class="col-12">
            <BQdtCard
              name="paymTreeMap"
              with-fullscreen
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BQdtCard } from '@/components/blocks'

export default {
  name: 'Payments',

  components: { BQdtCard },
}
</script>
